module.exports = __webpack_public_path__ + "static/media/tool_logo_zap.62021c39.png";